"use client";

import posthog from "posthog-js";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (posthog.__loaded) {
      posthog.captureException(error);
    }
  }, [error]);

  return (
    <html lang="fr">
      <body className="flex min-h-screen items-center justify-center" style={{ background: "#fdf9f4" }}>
        <div className="text-center px-6">
          <h2 className="text-xl font-semibold text-stone-900">Erreur critique</h2>
          <p className="text-stone-500 text-sm mt-2">
            L&apos;application a rencontré un problème. Veuillez recharger la page.
          </p>
          <button
            onClick={reset}
            className="mt-4 rounded-full bg-stone-900 px-6 py-2.5 text-sm font-medium text-white"
          >
            Recharger
          </button>
        </div>
      </body>
    </html>
  );
}
